var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "andon-bg p-4",
      style: {
        "background-image":
          "url(" + (_vm.selectedSetting && _vm.selectedSetting.imageUrl) + ")"
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("v-select", {
              attrs: { options: _vm.settings, label: "name" },
              model: {
                value: _vm.selectedSetting,
                callback: function($$v) {
                  _vm.selectedSetting = $$v
                },
                expression: "selectedSetting"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.selectedSetting
        ? [
            _c("div", { staticClass: "row my-1" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedSetting.title,
                      expression: "selectedSetting.title"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.selectedSetting.title },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.selectedSetting,
                        "title",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row my-1" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedSetting.targetValue,
                      expression: "selectedSetting.targetValue"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number", min: "0" },
                  domProps: { value: _vm.selectedSetting.targetValue },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.selectedSetting,
                        "targetValue",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row my-1" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedSetting.targetDescription,
                      expression: "selectedSetting.targetDescription"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.selectedSetting.targetDescription },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.selectedSetting,
                        "targetDescription",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row my-1" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedSetting.actualDescription,
                      expression: "selectedSetting.actualDescription"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.selectedSetting.actualDescription },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.selectedSetting,
                        "actualDescription",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row my-1" }, [
              _vm._m(5),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedSetting.previousDescription,
                      expression: "selectedSetting.previousDescription"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.selectedSetting.previousDescription },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.selectedSetting,
                        "previousDescription",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row my-1" }, [
              _c("div", { staticClass: "col" }, [
                _c("span", { staticClass: "float-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      on: { click: _vm.save }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("btnSave")))]
                  )
                ])
              ])
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-2" }, [
      _c("div", { staticClass: "h-100 d-inline-flex align-items-center" }, [
        _vm._v("Setting")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-2" }, [
      _c("div", { staticClass: "h-100 d-inline-flex align-items-center" }, [
        _vm._v("Titel")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-2" }, [
      _c("div", { staticClass: "h-100 d-inline-flex align-items-center" }, [
        _vm._v("Target")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-2" }, [
      _c("div", { staticClass: "h-100 d-inline-flex align-items-center" }, [
        _vm._v("Target Beschreibung")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-2" }, [
      _c("div", { staticClass: "h-100 d-inline-flex align-items-center" }, [
        _vm._v("Actual Beschreibung")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-2" }, [
      _c("div", { staticClass: "h-100 d-inline-flex align-items-center" }, [
        _vm._v("Previous Beschreibung")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }